import ScrollMagic from "scrollmagic";
import anime from "animejs";

export default class Urgent {
  constructor() {
    this._urgent = document.querySelector(".jsUrgent");
    this._urgentTxt = document.querySelector(".jsUrgentTxt");
    this._done = false;

    if (this._urgent && window.innerWidth > 1023) this.init();
  }

  showUrgent() {
    let timelineIn = anime.timeline();

    timelineIn
      .add({
        targets: this._urgent,
        translateY: [-50, 0],
        opacity: [0, 1],
        easing: "linear",
        offset: 200,
        duration: 550
      })
      .add({
        targets: this._urgentTxt,
        translateX: ["-100%", 0],
        opacity: [0, 1],
        easing: "easeInCubic",
        offset: 700,
        duration: 450
      });

    this._done = true;
  }

  init() {
    setTimeout(() => {
      this.showUrgent();
    }, 1500);
  }
}
